import {
  SELECT_COLLECTION_ROUTINE,
  CREATE_OR_UPDATE_COLLECTION_USER_ROUTINE,
  DELETE_COLLECTION_USER_ROUTINE,
} from "constants/ActionTypes";
import { createReducer } from "@reduxjs/toolkit";
import { normalizeEntity } from "reducers/reducerUtils";
import remove from "lodash/remove";

const initialState = {
  byId: {},
  allIds: [],
};

const collectionUsersReducer = createReducer(initialState, (builder) => {
  builder.addCase(SELECT_COLLECTION_ROUTINE.SUCCESS, (state, action) => {
    const { users } = action.payload;
    if (!users) {
      return state;
    }

    const { byId, allIds } = normalizeEntity(users);
    return {
      ...state,
      byId,
      allIds,
    };
  });
  builder.addCase(
    CREATE_OR_UPDATE_COLLECTION_USER_ROUTINE.SUCCESS,
    (state, action) => {
      const { call, collectionUser } = action.payload;

      state.byId[collectionUser._id] = collectionUser;
      if (call === "create") {
        state.allIds.push(collectionUser._id);
      }

      return state;
    }
  );
  builder.addCase(DELETE_COLLECTION_USER_ROUTINE.SUCCESS, (state, action) => {
    const { collectionUserId } = action.payload;
    delete state.byId[collectionUserId];
    remove(state.allIds, (id) => {
      return id === collectionUserId;
    });

    return state;
  });
});

export default collectionUsersReducer;
